import {Link, isRouteErrorResponse, useRouteError} from 'react-router';

import {PageShell} from '@/components/layout/page-shell.js';
import {Button} from '@/components/ui/button.js';
import {messageFor} from '@/lib/api-error.js';

/**
 * Route-level error element.
 *
 * @returns The rendered error page.
 */
export function RouteErrorBoundary(): React.JSX.Element {
  const error: unknown = useRouteError();
  const detail = isRouteErrorResponse(error)
    ? `${String(error.status)} ${error.statusText}`
    : messageFor(error);

  return (
    <PageShell>
      <div className="mx-auto w-full max-w-2xl px-4 py-24 text-center">
        <h1 className="text-3xl font-semibold tracking-tight">
          Something went wrong
        </h1>
        <p className="mt-3 text-muted-foreground">{detail}</p>
        <Button asChild className="mt-6">
          <Link to="/">Back to home</Link>
        </Button>
      </div>
    </PageShell>
  );
}
